import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ProfileAvatar from "../ProfileAvatar";
import { FormatToLocalSystemDateTime } from "./../../../utils/dateFormat";
import { getOrgType } from "./../../../utils/Token";
import GetfVDateFormate from "../../../utils/Genaricfunctions";
import RelativeTime from "../../../utils/RelativeTime";

function CommunicationListItem({
  prequalificationId,
  recentMessageId,
  messageText,
  unreadMessageCount,
  messageSentById,
  messageSentBy,
  vendorName,
  clientName,
  createdOn,
  accessType,
  totalMessageCount,
  prequalificationStart,
  prequalificationFinish,
  handleItemClick,
}) {
  return (
    <>
      <Box
        className="w-100 d-flex flex-nowrap py-2 cursor-pointer"
        onClick={handleItemClick.bind(
          null,
          prequalificationId,
          vendorName,
          clientName
        )}
      >
        <ProfileAvatar showUserIcon={true} />

        <Box className="ps-3 w-100" style={{ maxWidth: "calc(100% - 55px)" }}>
          <Box className=" w-100 d-flex justify-content-between">
            <Typography
              variant="body1"
              className="fw-semibold"
              sx={{
                fontSize: ".8rem",
                color: "#3e4a62",
                maxWidth: "calc(100% - 100px)",
              }}
            >
              {/* {
                getOrgType() === "Vendor"
                  ? <>
                    {clientName}
                    <br />
                    PQ Period : {GetfVDateFormate(prequalificationStart, '', '')} - {GetfVDateFormate(prequalificationFinish, '', '')}
                  </>
                  : getOrgType() === "Client"
                    ? <>
                      {vendorName}
                      <br />
                      PQ Period : {GetfVDateFormate(prequalificationStart, '', '')} - {GetfVDateFormate(prequalificationFinish, '', '')}
                    </>
                    : <>
                      {vendorName}
                      <br />
                      PQ Period : {GetfVDateFormate(prequalificationStart, '', '')} - {GetfVDateFormate(prequalificationFinish, '', '')}
                    </>
              } */}

              {getOrgType() === "Vendor" ? clientName : vendorName}
              <br />
              <span className="text-muted" style={{ color: "#667085", fontSize: "0.675rem" }}>
                PQ Period : {GetfVDateFormate(prequalificationStart, "", "")} -{" "}
                {GetfVDateFormate(prequalificationFinish, "", "")}
              </span>

            </Typography>
            <Typography
              variant="body2"
              className="text-muted"
              sx={{ color: "#667085", whiteSpace: "nowrap" }}
            >
              {/* {createdOn && FormatToLocalSystemDateTime(createdOn)}{" "} */}
              {createdOn && <RelativeTime createdOn={createdOn} />}{" "}
            </Typography>
          </Box>
          <Box className="w-100 d-flex align-items-center justify-content-between">
            <Typography
              variant="body2"
              className="text-truncate text-muted"
              sx={{
                color: "#667085",
                maxWidth: "calc(100% - 135px)",
                fontSize: "0.675rem",
              }}
            >
              {getOrgType() === "Admin" ? clientName : ""}
            </Typography>
          </Box>
          <Box className="w-100 d-flex align-items-center justify-content-between">
            <Typography
              variant="body2"
              className="text-truncate text-muted"
              sx={{ color: "#667085", maxWidth: "calc(100% - 135px)" }}
            >
              {messageSentBy}
              {messageSentBy && `:`} {messageText}
            </Typography>
            {unreadMessageCount !== 0 && (
              <Typography
                className="rounded p-1 px-2"
                style={{
                  backgroundColor: "#2a93db",
                  color: "#fff",
                  marginTop: "-4px",
                }}
                variant="body2"
              >
                {unreadMessageCount}
              </Typography>
            )}
          </Box>
        </Box>
      </Box >
    </>
  );
}

export default CommunicationListItem;
